// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Common - Start **/

.Layout4-noPadding-oTRqO {
    padding: 0px;
}

.Layout4-noMargin-fybOa {
    margin: 0px;
}

/** Common - End **/

/** Banner caption - Start **/

.Layout4-bannerCaptionContainer-VMHiv {
    position: relative;
}

.Layout4-bannerCaptionText-tymtt {
    font-size: 48px;
    line-height: 54px;
    color: var(--white-text);
    margin-bottom: 18px;
    font-weight: 600;
    text-align: center;
}

.Layout4-sectionWidth-c6gJx {
    max-width: 770px;
    margin: 0 auto;
    padding-top: 166px;
    padding-bottom: 166px;
}

.Layout4-bgCss-AW4YK {
    width: 100%;
    min-height: 768px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    background-color: var(--homePage-Banner-bg);
}

.Layout4-bannerCaptionPara-jT0pG {
    font-size: 18px;
    line-height: 26px;
    color: var(--white-text);
    margin: 0px;
    font-weight: 500;
    text-align: center;
}

@media (max-width:1199px) and (min-width:768px) {
    .Layout4-bannerCaptionContainer-VMHiv {
        padding-top: 50px;
    }

    .Layout4-sectionWidth-c6gJx {
        padding-left: 24px;
        padding-right: 24px;
    }
}

@media screen and (max-width: 767px) {
    .Layout4-sectionWidth-c6gJx {
        padding-left: 24px;
        padding-right: 24px;
    }

    .Layout4-bannerCaptionText-tymtt {
        font-size: 32px;
        line-height: 36px;
    }
}

/** Banner caption - End **/`, "",{"version":3,"sources":["webpack://./src/components/Home/Layout4/Layout4.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,mBAAmB;;AAEnB,6BAA6B;;AAC7B;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,2BAA2B","sourcesContent":["/** Common - Start **/\n\n.noPadding {\n    padding: 0px;\n}\n\n.noMargin {\n    margin: 0px;\n}\n\n/** Common - End **/\n\n/** Banner caption - Start **/\n.bannerCaptionContainer {\n    position: relative;\n}\n\n.bannerCaptionText {\n    font-size: 48px;\n    line-height: 54px;\n    color: var(--white-text);\n    margin-bottom: 18px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.sectionWidth {\n    max-width: 770px;\n    margin: 0 auto;\n    padding-top: 166px;\n    padding-bottom: 166px;\n}\n\n.bgCss {\n    width: 100%;\n    min-height: 768px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: 50% 50%;\n    background-color: var(--homePage-Banner-bg);\n}\n\n.bannerCaptionPara {\n    font-size: 18px;\n    line-height: 26px;\n    color: var(--white-text);\n    margin: 0px;\n    font-weight: 500;\n    text-align: center;\n}\n\n@media (max-width:1199px) and (min-width:768px) {\n    .bannerCaptionContainer {\n        padding-top: 50px;\n    }\n\n    .sectionWidth {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .sectionWidth {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n\n    .bannerCaptionText {\n        font-size: 32px;\n        line-height: 36px;\n    }\n}\n\n/** Banner caption - End **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noPadding": `Layout4-noPadding-oTRqO`,
	"noMargin": `Layout4-noMargin-fybOa`,
	"bannerCaptionContainer": `Layout4-bannerCaptionContainer-VMHiv`,
	"bannerCaptionText": `Layout4-bannerCaptionText-tymtt`,
	"sectionWidth": `Layout4-sectionWidth-c6gJx`,
	"bgCss": `Layout4-bgCss-AW4YK`,
	"bannerCaptionPara": `Layout4-bannerCaptionPara-jT0pG`
};
module.exports = ___CSS_LOADER_EXPORT___;
